/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { toPercentage } from "../../Layers/fields/formatters";
import { RipeningDenominator } from "../hooks/getRipeningClasses";

export function ClassDistribution({ classes, total, totalPallets, denominator, showPercent, hideNumberOfCheckedPallets }) {
    // Filter out the "checked" class if hideNumberOfCheckedPallets is true
    const filteredClasses = hideNumberOfCheckedPallets
        ? classes.filter((item) => item.value !== "checked")
        : classes;

    return <div>
        <div className="w-100 position-relative py-2 mb-2 rounded" css={css`overflow: hidden; background: #555;`}>
            {filteredClasses?.filter((i) => !i.hide_bar)?.reverse()?.map((item, index) => (
                <div
                    key={index}
                    className="position-absolute py-2"
                    css={css`left: 0; top: 0; bottom: 0; background-color: ${item.color}; right: ${toPercentage(total - item.cumulative, total, 3)}`}
                />
            ))}
        </div>

        <div className="text-center">
            {filteredClasses.map((item, index) => {
                return (
                    <div className={`d-flex justify-content-between ${item.className || ""}`} key={index}>
                        <span>{item.label}:</span>
                        {item.count === 0 && <span className="text-muted">-</span>}
                        {showPercent && item.count > 0 && <span className="fw-bold" css={css`color: ${item.color};`} >{toPercentage(item.count, item.value === "checked" || (denominator as any) === RipeningDenominator.all_pallets ? totalPallets : total, 1) || "-"}</span>}
                        {!showPercent && item.count > 0 && <span className="fw-bold" css={css`color: ${item.color};`} ><span className="">{item.count || "-"}</span>/{item.value === "checked" || (denominator as any) === RipeningDenominator.all_pallets ? totalPallets : total}</span>}
                    </div>
                );
            })}
        </div>
    </div>;
}
